<div class="message-list-option animated fadeIn">
	<ng-container *ngFor="let item of elements.payload.options; let i = index">
		<div class="list-option-group">
			<div class="list-option-group-content">
				<div class="title">{{ item.title }}</div>
				<div class="subtitle">{{ item.subtitle }}</div>
				<div class="buttons">
					<ng-container *ngFor="let button of item.buttons">
						<button type="button" class="button" (click)="addMessage(button)" *ngIf="button.type === 'postback'">
							{{ button.text }}
						</button>
						<button type="button" class="button" (click)="openUrl(button.intent)" *ngIf="button.type === 'web_url'">
							{{ button.text }}
						</button>
					</ng-container>
				</div>
			</div>
			<div class="list-option-group-image">
				<img [src]=" item.image_urlfeUrl " class="image">
			</div>
		</div>
	</ng-container>
</div>